<template>
  <v-footer
    class="pa-0 page-footer"
    :class="$vuetify.breakpoint.smAndDown ? 'page-footer--mobile' : 'page-footer--desktop'"
  >
    <v-sheet :height="tailleFooter" />
    <Transition transitionPosition="top" transitionRotate="0" />
    <v-col class="text-center" cols="12">
      <p class="my-0">{{ new Date().getFullYear() }} — <strong>InfographArt</strong></p>
      <p class="my-0">
        <v-icon class="mr-1" small>mdi-gitlab</v-icon>v{{ version }}
        <span v-if="gitSha"> • <v-icon class=" mr-1" small>mdi-source-branch</v-icon>{{ gitSha }}</span>
      </p>
    </v-col>
    <v-sheet :height="bottomSpacer" />
  </v-footer>
</template>

<script>
import packago from "../../package.json";
import Transition from "@/components/graphics/transition";

export default {
  name: "Bottom",
  components: {
    Transition,
  },
  data() {
    return {
      version: packago.version,
    };
  },
  computed: {
    gitSha() {
      if (process.env.VUE_APP_GIT_SHA) return process.env.VUE_APP_GIT_SHA.slice(0, 7); else return false;
    },
    tailleFooter() {
      return this.$vuetify.breakpoint.smAndDown ? 48 : 200;
    },
    bottomSpacer() {
      return this.$vuetify.breakpoint.smAndDown ? 32 : 100;
    },
  },
};
</script>

<style scoped>
.page-footer--desktop {
  margin-top: 150px;
}

.page-footer--mobile {
  margin-top: 48px;
}
</style>
